module.exports = __webpack_public_path__ + "static/5-1200-2c3273bac921494437937e8d4240dd01.png";